import { createRoot } from "react-dom/client";
import App from "./App";
import "./hooks/admin";
import "./index.css";
import "./core/zod";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
